import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { getVehicles } from '../../services/VehicleServices'; 
import Swal from 'sweetalert2';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './Layout.css';

const Layout = () => {

  const navigate = useNavigate(); 
  const [vehicles, setVehicles] = useState([]); 

  useEffect(() => {
    getVehicles().then((resdata) => {
      setVehicles(resdata);  
    }).catch(err => {
      console.error(err);
      Swal.fire('Errore', 'Impossibile caricare i veicoli', 'error');
    });
  }, []);

  return (
    <div className="layout-container">
      <Header navigate={navigate} />
      <main>
        <Outlet context={{ vehicles, setVehicles }}/>
      </main>
      <Footer />
    </div>
  );
  
};

export default Layout;